import { FC } from "react";

import { TInvestigationSwatch } from "../investigation.models";
import { ToggleChipStyled } from "../investigation.workspace.styled";
import { FilterSwatch } from "./investigation.filter-swatch";

export interface IFilterToggleProps {
  active: boolean;
  color: string;
  label: string;
  swatch: TInvestigationSwatch;
  disabled?: boolean;
  onToggle: () => void;
}

/** A single layer toggle chip for the map top bar (swatch + label; active = colored border/text). */
export const FilterToggle: FC<IFilterToggleProps> = ({
  active,
  color,
  label,
  swatch,
  disabled,
  onToggle,
}) => (
  <ToggleChipStyled
    type="button"
    $active={active}
    $color={color}
    disabled={disabled}
    onClick={onToggle}
    aria-pressed={active}
  >
    <FilterSwatch swatch={swatch} color={color} active={active} />
    {label}
  </ToggleChipStyled>
);
